import React from "react";
import { settings } from "../shim/jsbridge";

const { EULA_LINK } = settings || {};
const description = "End User License Agreement";

const EulaLink = ({ includeFullDescription = false }) => (
  <a href={EULA_LINK} title="ReversingLabs, Inc. End User License Agreement">
    {includeFullDescription && "ReversingLabs, Inc. "} {description}
  </a>
);

export default EulaLink;
